import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

export interface QuotaVariationProps {
  quota?: number;
}

type QuotaVariation = {
  quota: number;
  isIncreasing: boolean;
  isDecreasing: boolean;
  isArrowVisible: boolean;
};
export const useQuotaVariation = (props?: QuotaVariationProps) => {
  const { quota = 0 } = props ?? {};

  const [st, setSt] = useState<QuotaVariation>({
    quota,
    isIncreasing: false,
    isDecreasing: false,
    isArrowVisible: false,
  });

  const refTmr = useRef<ReturnType<typeof setTimeout>>();

  const doKillArrow = () => {
    clearTimeout(refTmr.current);
    setSt((prev) => ({ ...prev, isArrowVisible: false }));
  };

  useEffect(() => {
    setSt((prev) => {
      const newQuota = quota ?? 0;
      if (newQuota < 1) {
        return {
          ...prev,
          quota: newQuota,
          isArrowVisible: false,
        };
      } else if (newQuota !== prev.quota) {
        refTmr.current = setTimeout(doKillArrow, 5000);
        return {
          quota: newQuota,
          isArrowVisible: true,
          isIncreasing: newQuota > prev.quota,
          isDecreasing: newQuota < prev.quota,
        };
      }
      return prev;
    });
  }, [quota]);

  useEffect(() => {
    return () => {
      clearTimeout(refTmr.current);
    };
  }, []);

  return [st.isArrowVisible, st.isIncreasing, st.isDecreasing];
};
